

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import UcMenuSubComponent from "./uc-menu-sub.vue";
@Component({
  name: "uc-menu-item"
})
export default class UcMenuItemComponent extends Vue {
  @Prop({ type: String })
  title: string;

  @Prop({ type: String })
  url!: string;
  @Prop({ type: String })
  prefix!: string;

  @Prop({ type: String, default: null })
  icon!: string;

  // iconClass = this.icon;
  isSubMenu = false;
  isShow = false;

  beforeCreate() {
    const defaultSlots = this.$slots.default;

    if (defaultSlots) {
      if (defaultSlots.length > 1) {
        throw new Error(
          "uc-menu-item не может содержать более одного компонента"
        );
      }

      if (!this.GetChildAny("uc-menu-sub")) {
        throw new Error(
          "uc-menu-item внутри может содержать только один компонент menu-sub"
        );
      }
    }
  }

  mounted() {
    if (this.isActiveSubMenu()) this.setSubMenuShow();

    if (this.icon) {
      var aa = this.$el as HTMLElement;
      aa.style.backgroundImage = this.icon;
    }
    if (this.title) {
    }
  }

  isActiveLink() {
    //  console.log("isActiveLink",this.$route.path, this.url,this.$route.path == this.url)
    return this.$route.path == this.url;
  }
  isActiveSubMenu() {
    //  console.log("isActiveSubMenu",this.prefix, this.$route.name,  this.prefix && this.$route.name.includes(this.prefix) );
    return this.prefix && this.$route.name.includes(this.prefix);
  }

  click(e: any) {
    if (!this.setSubMenuShow()) {
      // location.href = this.url;
      // history.pushState(null, "page 2", this.url);
    } else {
      // console.log('--setSubMenuShow--', this.isShow);
      this.isShow = !this.isShow;
    }
  }
  setSubMenuShow() {
    // const defaultSlots:any = this.$slots.default;
    // debugger
    // if (defaultSlots) {
    //   defaultSlots.forEach((vnode:any) => {
    //     vnode.componentInstance.isShow = !vnode.componentInstance.isShow;

    //   });
    //   return true;
    // } else {
    //   return false;
    // }

    var defaultSlots = this.$children.filter(
      el => el instanceof UcMenuSubComponent
    ) as UcMenuSubComponent[];

    if (defaultSlots) {
      defaultSlots.forEach(vnode => {
        // console.log('setSubMenuShow', vnode.isShow);
        vnode.isShow = !vnode.isShow;
      });
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/menu/uc-menu-item.vue